import { render, staticRenderFns } from "./DeliveryTime.vue?vue&type=template&id=4f1b33ac&scoped=true&"
import script from "./DeliveryTime.vue?vue&type=script&lang=js&"
export * from "./DeliveryTime.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTime.vue?vue&type=style&index=0&id=4f1b33ac&prod&lang=scss&"
import style1 from "./DeliveryTime.vue?vue&type=style&index=1&id=4f1b33ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1b33ac",
  null
  
)

export default component.exports